import { FC, HTMLAttributes, ReactNode } from 'react';
import * as CSS from 'csstype';
import styled, { CSSObject } from 'styled-components';

type Props = HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode;
  direction?: CSS.Property.FlexDirection;
  justifyContent?: CSS.Property.JustifyContent;
  alignItems?: CSS.Property.AlignItems;
  gap?: number;
  padding?: number;
  style?: CSSObject;
  className?: string;
  dataTestId?: string;
};

export const Row: FC<Props> = ({
  dataTestId = 'row',
  alignItems = 'center',
  justifyContent = 'flex-start',
  gap = 10,
  padding,
  direction,
  style,
  children,
  className,
  ...rest
}) => {
  return (
    <Wrapper
      data-testid={dataTestId}
      $justifyContent={justifyContent}
      $alignItems={alignItems}
      $direction={direction}
      $gap={gap}
      $padding={padding}
      style={style}
      className={className}
      {...rest}
    >
      {children}
    </Wrapper>
  );
};

const Wrapper = styled.div<{
  $justifyContent: CSS.Property.JustifyContent;
  $alignItems: CSS.Property.AlignItems;
  $direction?: CSS.Property.FlexDirection;
  $gap?: number;
  $padding?: number;
  style?: CSSObject;
}>`
  width: 100%;
  display: flex;
  flex-direction: ${({ $direction }) => $direction};
  justify-content: ${({ $justifyContent }) => $justifyContent};
  align-items: ${({ $alignItems }) => $alignItems};
  gap: ${({ $gap }) => $gap}px;
  padding: ${({ $padding }) => $padding}px;
`;
